import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/deposit/chime';
import {createChimeOrder} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Send from './send';
import Alert from './alert';

export default ({setMethod}) => {
    const {chime_recipient, chime_order} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const [stage, setStage] = useState('enter'),
          [data, setData] = useState(null);

    if(stage === "enter")
        return <Enter setMethod={setMethod} onNext={data => {
            data = {
                ...data,
                amount: parseFloat(parseFloat(data.amount).toFixed(2))
            };

            dispatch(createChimeOrder({
                amount: data.amount,
                name: data.name
            }, navigate));

            setData(data);
            setStage('send');
        }} />

    if(stage === "send")
        return <Send data={data} chime_order={chime_order} onPayment={() => setStage('alert')} />;

    return <Alert order={chime_order} />
}